<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit Large Shareholder</h2>
      @if (largeShareholderData?.name) {
        <p class="component-header-subtitle">
          @if (largeShareholderData?.code) {
            <span class="large-shareholder-code">{{ largeShareholderData?.code }}</span>
          }
          {{ largeShareholderData?.name }}
        </p>
      }
      @if (form.get('year')?.value) {
        <p class="component-header-subtitle-secondary">{{ form.get('year')?.value }}</p>
      }
    </div>

    <div class="button-group">
      @if (fromCompanyId) {
        <a [routerLink]="['/companies/edit', fromCompanyId]" [queryParams]="{ tab: 'ownership', year: fromCompanyYear }" class="back-to-company-link">
          <mat-icon>open_in_new</mat-icon>
          {{ fromCompanyName || 'Company' }} — Ownership
        </a>
      }
      <button mat-raised-button color="primary" (click)="onAddPyramidItem()" *ngIf="isPyramidTabActive">
        <mat-icon>add</mat-icon>
        Add new pyramid item
      </button>
      <!-- A large shareholder may have at most one active connection; hide "Add" once one exists
           (the backend enforces the same rule and returns a clear message if bypassed). -->
      <button mat-raised-button color="primary" (click)="onAddConnectionItem()" *ngIf="isConnectionTabActive && connections.length === 0">
        <mat-icon>add</mat-icon>
        Add new connection item
      </button>
    </div>
  </div>
  <app-large-shareholder-form
    #largeShareholderForm
    [form]="form"
    [isEditMode]="true"
    [showYearWarning]="showYearWarning"
    [pyramid]="largeShareholderData?.pyramid || []"
    [pyramidEntitySummaries]="pyramidEntitySummaries"
    [pyramidEntriesByYear]="pyramidEntriesByYearRaw"
    [connections]="connections"
    [holdings]="holdings"
    [initialTabIndex]="initialTabIndex"
    submitButtonText="Update Large Shareholder"
    (submit)="onSubmit()"
    (cancel)="onCancel()"
    (yearChange)="onYearChange($event)"
    (deleteConnection)="onDeleteConnection($event)"
    (editPyramidItem)="onEditPyramidItem($event)"
    (deletePyramidItem)="onDeletePyramidItem($event)"
    (deleteEntityYear)="onDeleteEntityYear($event)"
    (deletePyramidYear)="onDeletePyramidYear($event)">
  </app-large-shareholder-form>
</div>
